import React from "react";
import ReactDOM from "react-dom";
import App from "./components/NewExistingOwner/App";

const el = document.getElementById("ownerForm");
el && ReactDOM.render(<App />, el);
